import React from 'react'
// import Ab from "../../images/about/img-2.jpg"
import Ab from "../../images/faxian-it-images/about-back.jpg"
// import Ab2 from "../../images/about/img-3.jpg"
import Ab2 from "../../images/faxian-it-images/boss.jpg"
import Ab3 from "../../images/about/signeture.png"

const About2 = () => {
    return (
        <section className="about-section-s2 section-padding">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-xl-6 col-12">
                        <div className="about-left-content">
                            <div className="image-1">
                                <img src={Ab} alt="" />
                            </div>
                            <div className="image-2">
                                <img src={Ab2} alt="" />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-6 col-12">
                        <div className="about-right-content">
                            <h2 className="title">ABOUT FAXIAN IT</h2>
                            <h3 className="sub-title">We Are a Trusted IT Solution Company</h3>
                            <p className="text">As a business increasingly rely on technology, IT services have become essential for ensuring the effective and efficient management of IT infrastructures. FaxianIT is a pioneer in the IT consultancy business with years off experience and empathy towards our mission to help the world progress. Below is our mission statement and structural functionality on how we proceed to help you with your goals.
                            </p>
                            <div className="ceo-content">
                                <h2>Venkata Ramineni</h2>
                                <span>CEO & Founder of Faxian IT</span>
                                <div className="signeture">
                                    {/* <img src={Ab3} alt="" /> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default About2;